import { useCallback } from "react";
import { useLazyQuery } from "@apollo/client";

/**
 * useGetLazyQuery
 * @param {Object} gql
 * @returns
 */
const useGetLazyQuery = (gql, fetchPolicy = "cache-first", nextFetchPolicy) => {
  const [getLazyQuery, { loading }] = useLazyQuery(gql);

  /**
   * 検索処理
   * @param {Object} params 検索条件 ※検索条件が不要な場合nullを受け取る
   * @param {Function} onSuccess 成功処理関数
   * @param {Function} onError エラー処理関数
   */
  const query = useCallback(
    async (params, onSuccess, onError) => {
      await getLazyQuery({
        fetchPolicy: fetchPolicy,
        nextFetchPolicy: nextFetchPolicy,
        variables: params,
      })
        .then((res) => {
          const data = Object.values(res.data)[0];
          onSuccess(data);
        })
        .catch((e) => {
          onError(e);
        });
    },
    [getLazyQuery]
  );

  return [query, loading];
};

export default useGetLazyQuery;
